import React, { useRef } from 'react';
import GeneralStatus from '../../GeneralStatus';
import { BattlePlayerRankCorner } from '../../pvp/battlePlayerRankCorner';
import { MOBILE_BATTLE_DOCK_LIFT_PX } from './mobileBattleLayoutOffsets';
import { ExploreUnknownAflamePortraitFlames } from '../ExploreUnknownAflamePortraitFlames';
import '../ExploreUnknownAflamePortraitFlames.css';

/**
 * Mobile Player Avatar (General) Component
 * Positioned at bottom-left, above the resign button
 */
export const MobilePlayerAvatar = ({
  you,
  playerDamageFlash,
  playerRank,
  playerPvpLadder,
  selectedGeneral,
  avatars,
  getAvatarImage,
  getDamageFlashStyles,
  shouldMirrorAvatar,
  getRankStyle,
  calculateFactionFromStrategy,
  getTranslatedFactionName,
  yourTurn,
  barrierVisualResetKey = null,
  isExploreUnknownAflame = false,
}) => {
  const portraitAnchorRef = useRef(null);

  return (
    <div className="player-avatar-container-mobile" style={{ 
      position: "absolute", 
      left: "5px",
      bottom: `${45 + MOBILE_BATTLE_DOCK_LIFT_PX}px`,
      zIndex: 1000,
      transform: "scale(0.4)",
      transformOrigin: "bottom left"
    }}>
      <div style={{ position: "relative", display: "inline-block" }}>
        <GeneralStatus
          health={you.health}
          intelligenceLeft={you.intelligence}
          intelligenceTotal={you.maxIntelligence}
          barriersRemoved={you.barriersRemoved ?? []}
          barrierVisualResetKey={barrierVisualResetKey}
          damageFlash={playerDamageFlash}
          playerCompact={true}
          factionName={calculateFactionFromStrategy(you.strategy)}
          translatedFactionName={getTranslatedFactionName(calculateFactionFromStrategy(you.strategy))}
          isActiveTurn={yourTurn}
        />
        <div
          className="player-hud-portrait-clip"
          style={{ position: "relative", width: "180px", height: "180px", display: "inline-block" }}
        >
          <img 
            ref={portraitAnchorRef}
            src={getAvatarImage(selectedGeneral)} 
            alt="Player General"
            data-zone="player_general"
            data-eu-aflame={isExploreUnknownAflame ? 'true' : undefined}
            className={isExploreUnknownAflame ? 'player-hud-avatar-aflame' : undefined}
            style={{ 
              width: "100%", 
              height: "100%", 
              objectFit: "contain",
              display: "block",
              ...getDamageFlashStyles(playerDamageFlash),
              transform: shouldMirrorAvatar(selectedGeneral, 'left', avatars) ? 'scaleX(-1)' : 'none',
            }} 
          />
          <BattlePlayerRankCorner
            playerRank={playerRank}
            playerPvpLadderRow={playerPvpLadder}
            getRankStyle={getRankStyle}
          />
        </div>
        {isExploreUnknownAflame ? (
          <ExploreUnknownAflamePortraitFlames anchorRef={portraitAnchorRef} active />
        ) : null}
      </div>
    </div>
  );
};

export default MobilePlayerAvatar;
